
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 980 980"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M456 1.1C352.5 8.6 256.2 47.4 176 113.9c-15 12.3-50.1 47.5-62.2 62.1C25.7 282.8-13.2 416.3 4 552.5 15.9 645.9 54.1 732.6 116.4 807c9.8 11.7 37 39.3 49.6 50.4 132.8 116.6 315.8 153.1 482.5 96.2 89.5-30.5 170-87.9 228.1-162.7 54-69.5 88.4-152 99.3-238.4 17.8-141-24.7-279.7-118.5-386.5-11.2-12.8-38.6-39.8-50.9-50.1C730.2 51.7 640 13.3 540 2.5 522.6.6 473.6-.2 456 1.1zM517.6 149c6.5 1.1 17 3.8 23.4 5.9 78.7 26.3 124.3 106.1 107.4 187.9-9.7 46.9-44.2 90.7-88 111.8-25.7 12.3-56.9 18-83.9 15.4-34.7-3.4-64.2-15.4-89.7-36.7-54-44.9-73.1-119.3-47.3-184.4 20.5-51.8 67.5-90.2 122.1-99.8 15.5-2.7 40.2-2.8 56-.1zm99.9 403.8c66.3 15.1 113.6 62.6 127.6 128.2 1.8 8.5 2.3 13.8 2.3 28 .1 15.7-.1 18.2-2.2 24.5-5.1 15.4-13.2 25.8-30.4 39.6-102.8 82.1-242.9 101.6-364.2 50.8-30-12.6-60.5-30.7-85.6-50.8-19.1-15.3-26.3-25.1-31.1-42.8-1.9-7-2.1-9.5-1.6-24.8.8-24.2 5.3-42.6 15.7-63.9 20.6-42.1 59.6-74.4 104.2-86.2 20.5-5.4 17.1-5.3 140.8-5l114.5.2 10 2.2z"}})])
          )
        }
      }
    